"use client";

import { useEffect } from "react";
import { reportClientError } from "../lib/report-client-error";

export function ErrorMonitor() {
	useEffect(() => {
		const handleError = (event: ErrorEvent) => {
			reportClientError("window", event.error ?? event.message, {
				filename: event.filename ?? "",
				position: `${event.lineno}:${event.colno}`,
			});
		};

		const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
			reportClientError("unhandledrejection", event.reason);
		};

		window.addEventListener("error", handleError);
		window.addEventListener("unhandledrejection", handleUnhandledRejection);

		return () => {
			window.removeEventListener("error", handleError);
			window.removeEventListener(
				"unhandledrejection",
				handleUnhandledRejection,
			);
		};
	}, []);

	return null;
}
